// extracted by mini-css-extract-plugin
export default {"nav":"shop_nav__nav--v7K6","link":"shop_nav__link--D7-q","link__selected":"shop_nav__link__selected--NizM"};